"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackToolbar_exports = {};
__export(StackToolbar_exports, {
  StackToolbar: () => StackToolbar,
  StackToolbarBadge: () => StackToolbarBadge,
  StackToolbarButton: () => StackToolbarButton,
  StackToolbarIcon: () => StackToolbarIcon,
  StackToolbarLabel: () => StackToolbarLabel,
  StackToolbarMenu: () => StackToolbarMenu,
  StackToolbarMenuAction: () => StackToolbarMenuAction,
  StackToolbarSearchBarSlot: () => StackToolbarSearchBarSlot,
  StackToolbarSpacer: () => StackToolbarSpacer,
  StackToolbarView: () => StackToolbarView,
  appendStackToolbarPropsToOptions: () => appendStackToolbarPropsToOptions
});
module.exports = __toCommonJS(StackToolbar_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_native = require("@react-navigation/native");
var import_react = require("react");
var import_react_native = require("react-native");
var import_menu = require("../menu");
var import_toolbar = require("../toolbar");
var import_use_isomorphic_layout_effect = require("@vxrn/use-isomorphic-layout-effect");
function isChildOfType(element, type) {
  return /* @__PURE__ */ (0, import_react.isValidElement)(element) && element.type === type;
}
var StackToolbarPlacementContext = /* @__PURE__ */ (0, import_react.createContext)(null);
function StackToolbarLabel(_props) {
  return null;
}
function StackToolbarIcon(_props) {
  return null;
}
function StackToolbarBadge(_props) {
  return null;
}
function getToolbarContent(children, icon, iconRenderingMode) {
  var label = "";
  var iconProps = typeof icon === "string" ? {
    sf: icon
  } : icon ? {
    src: icon,
    renderingMode: iconRenderingMode
  } : void 0;
  var badge;
  import_react.Children.forEach(children, function(child) {
    if (typeof child === "string" || typeof child === "number") {
      label += String(child);
    } else if (isChildOfType(child, StackToolbarLabel)) {
      var _child_props_children;
      label = (_child_props_children = child.props.children) !== null && _child_props_children !== void 0 ? _child_props_children : "";
    } else if (isChildOfType(child, StackToolbarIcon)) {
      iconProps = child.props;
    } else if (isChildOfType(child, StackToolbarBadge)) {
      badge = child.props;
    }
  });
  return {
    label,
    icon: iconProps,
    badge
  };
}
function getHeaderIcon(content, tintColor) {
  var _content_icon, _content_icon1, _content_icon2;
  if ((_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.sf) {
    return {
      type: "sfSymbol",
      name: content.icon.sf
    };
  }
  if ((_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.src) {
    var _content_icon_renderingMode;
    return {
      type: "image",
      source: content.icon.src,
      tinted: ((_content_icon_renderingMode = content.icon.renderingMode) !== null && _content_icon_renderingMode !== void 0 ? _content_icon_renderingMode : tintColor ? "template" : "original") === "template"
    };
  }
  if ((_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.xcasset) {
    var _content_icon_renderingMode1;
    return {
      type: "image",
      source: {
        uri: content.icon.xcasset
      },
      tinted: ((_content_icon_renderingMode1 = content.icon.renderingMode) !== null && _content_icon_renderingMode1 !== void 0 ? _content_icon_renderingMode1 : tintColor ? "template" : "original") === "template"
    };
  }
  return void 0;
}
function getHeaderItemSharedProps(props, content) {
  var _props_accessibilityLabel, _content_badge_children;
  var _content_badge;
  var labelStyle = import_react_native.StyleSheet.flatten(props.style);
  var badgeStyle = import_react_native.StyleSheet.flatten((_content_badge = content.badge) === null || _content_badge === void 0 ? void 0 : _content_badge.style);
  return {
    label: content.label,
    labelStyle,
    icon: getHeaderIcon(content, props.tintColor),
    variant: props.variant,
    tintColor: props.tintColor,
    disabled: props.disabled,
    hidesSharedBackground: props.hidesSharedBackground,
    sharesBackground: !props.separateBackground,
    accessibilityLabel: (_props_accessibilityLabel = props.accessibilityLabel) !== null && _props_accessibilityLabel !== void 0 ? _props_accessibilityLabel : content.label,
    accessibilityHint: props.accessibilityHint,
    badge: content.badge ? {
      value: (_content_badge_children = content.badge.children) !== null && _content_badge_children !== void 0 ? _content_badge_children : "",
      style: badgeStyle
    } : void 0
  };
}
function getMenuItems(children) {
  return import_react.Children.toArray(children).map(function(child) {
    if (isChildOfType(child, StackToolbarMenuAction)) {
      var _child_props_onPress;
      var content = getToolbarContent(child.props.children, child.props.icon, child.props.iconRenderingMode);
      return {
        type: "action",
        label: content.label,
        description: child.props.subtitle,
        icon: getHeaderIcon(content, child.props.tintColor),
        onPress: (_child_props_onPress = child.props.onPress) !== null && _child_props_onPress !== void 0 ? _child_props_onPress : function() {
        },
        state: child.props.isOn ? "on" : "off",
        disabled: child.props.disabled,
        destructive: child.props.destructive,
        hidden: child.props.hidden,
        keepsMenuPresented: child.props.unstable_keepPresented,
        discoverabilityLabel: child.props.discoverabilityLabel
      };
    }
    if (isChildOfType(child, StackToolbarMenu)) {
      var content1 = getToolbarContent(child.props.children, child.props.icon, child.props.iconRenderingMode);
      return {
        type: "submenu",
        label: content1.label || child.props.title || "",
        icon: getHeaderIcon(content1, child.props.tintColor),
        inline: child.props.inline,
        layout: child.props.palette ? "palette" : "default",
        destructive: child.props.destructive,
        multiselectable: child.props.singleSelection === false,
        items: getMenuItems(child.props.children)
      };
    }
    return null;
  }).filter(function(item) {
    return Boolean(item);
  });
}
function convertToolbarChildToHeaderItem(child) {
  if (isChildOfType(child, StackToolbarButton)) {
    var _child_props_onPress;
    if (child.props.hidden) return null;
    var content = getToolbarContent(child.props.children, child.props.icon, child.props.iconRenderingMode);
    return {
      ...getHeaderItemSharedProps(child.props, content),
      type: "button",
      onPress: (_child_props_onPress = child.props.onPress) !== null && _child_props_onPress !== void 0 ? _child_props_onPress : function() {
      },
      selected: child.props.selected
    };
  }
  if (isChildOfType(child, StackToolbarMenu)) {
    if (child.props.hidden) return null;
    var content1 = getToolbarContent(child.props.children, child.props.icon, child.props.iconRenderingMode);
    var contentWithTitle = {
      ...content1,
      label: content1.label || child.props.title || ""
    };
    return {
      ...getHeaderItemSharedProps(child.props, contentWithTitle),
      type: "menu",
      menu: {
        title: child.props.title,
        multiselectable: child.props.singleSelection === false,
        layout: child.props.palette ? "palette" : "default",
        items: getMenuItems(child.props.children)
      }
    };
  }
  if (isChildOfType(child, StackToolbarSpacer)) {
    if (child.props.hidden) return null;
    if (child.props.width === void 0) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("StackToolbar.Spacer requires a width in header placements.");
      }
      return null;
    }
    return {
      type: "spacing",
      spacing: child.props.width
    };
  }
  if (isChildOfType(child, StackToolbarView)) {
    if (child.props.hidden) return null;
    return {
      type: "custom",
      element: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Fragment, {
        children: child.props.children
      }),
      hidesSharedBackground: child.props.hidesSharedBackground
    };
  }
  return null;
}
function appendStackToolbarPropsToOptions(options, props) {
  var _props_placement;
  if (import_react_native.Platform.OS !== "ios") return options;
  var placement = (_props_placement = props.placement) !== null && _props_placement !== void 0 ? _props_placement : "bottom";
  if (placement === "bottom") {
    if (process.env.NODE_ENV !== "production") {
      console.warn("StackToolbar with bottom placement must be rendered in a page component.");
    }
    return options;
  }
  if (placement !== "left" && placement !== "right") {
    throw new Error(`Invalid placement "${placement}" for StackToolbar. Expected "left", "right", or "bottom".`);
  }
  if (props.asChild) {
    return placement === "left" ? {
      ...options,
      headerShown: true,
      headerLeft: function() {
        return props.children;
      }
    } : {
      ...options,
      headerShown: true,
      headerRight: function() {
        return props.children;
      }
    };
  }
  var allChildren = import_react.Children.toArray(props.children);
  var items = allChildren.map(convertToolbarChildToHeaderItem).filter(function(item) {
    return Boolean(item);
  });
  if (process.env.NODE_ENV !== "production" && items.length !== allChildren.length) {
    var invalidChildren = allChildren.filter(function(child) {
      return !isChildOfType(child, StackToolbarButton) && !isChildOfType(child, StackToolbarMenu) && !isChildOfType(child, StackToolbarSpacer) && !isChildOfType(child, StackToolbarView);
    });
    if (invalidChildren.length) {
      console.warn(`StackToolbar with placement="${placement}" only accepts StackToolbar.Button, Menu, Spacer, and View children.`);
    }
  }
  var getItems = function() {
    return items;
  };
  return placement === "left" ? {
    ...options,
    headerShown: true,
    unstable_headerLeftItems: getItems
  } : {
    ...options,
    headerShown: true,
    unstable_headerRightItems: getItems
  };
}
function StackToolbarComponent(props) {
  var _props_placement;
  var parentPlacement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var navigation = (0, import_native.useNavigation)();
  var placement = (_props_placement = props.placement) !== null && _props_placement !== void 0 ? _props_placement : "bottom";
  var options = (0, import_react.useMemo)(function() {
    return placement === "bottom" ? {} : appendStackToolbarPropsToOptions({}, props);
  }, [
    placement,
    props.asChild,
    props.children
  ]);
  if (parentPlacement) {
    throw new Error("StackToolbar cannot be nested inside another StackToolbar.");
  }
  (0, import_use_isomorphic_layout_effect.useIsomorphicLayoutEffect)(function() {
    if (import_react_native.Platform.OS !== "ios" || placement === "bottom") return;
    navigation.setOptions(options);
  }, [
    navigation,
    options,
    placement
  ]);
  if (import_react_native.Platform.OS !== "ios" || placement !== "bottom") return null;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StackToolbarPlacementContext.Provider, {
    value: "bottom",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_toolbar.ToolbarHost, {
      children: props.children
    })
  });
}
function StackToolbarButton(props) {
  var _props_image, _ref, _ref1, _props_accessibilityLabel;
  var _content_badge, _content_icon, _content_icon1, _content_icon2, _content_icon3;
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.Button must be used inside StackToolbar.");
  var content = getToolbarContent(props.children, props.icon, props.iconRenderingMode);
  var badgeStyle = import_react_native.StyleSheet.flatten((_content_badge = content.badge) === null || _content_badge === void 0 ? void 0 : _content_badge.style);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_toolbar.ToolbarItem, {
    identifier,
    title: content.label,
    systemImageName: (_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.sf,
    xcassetName: (_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.xcasset,
    image: (_props_image = props.image) !== null && _props_image !== void 0 ? _props_image : (_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.src,
    imageRenderingMode: (_ref = (_ref1 = (_content_icon3 = content.icon) === null || _content_icon3 === void 0 ? void 0 : _content_icon3.renderingMode) !== null && _ref1 !== void 0 ? _ref1 : props.iconRenderingMode) !== null && _ref !== void 0 ? _ref : props.tintColor ? "template" : "original",
    tintColor: props.tintColor,
    hidesSharedBackground: props.hidesSharedBackground,
    sharesBackground: !props.separateBackground,
    barButtonItemStyle: props.variant === "done" ? "prominent" : props.variant,
    hidden: props.hidden,
    selected: props.selected,
    badgeConfiguration: content.badge ? {
      value: content.badge.children,
      backgroundColor: badgeStyle === null || badgeStyle === void 0 ? void 0 : badgeStyle.backgroundColor,
      color: badgeStyle === null || badgeStyle === void 0 ? void 0 : badgeStyle.color,
      fontFamily: badgeStyle === null || badgeStyle === void 0 ? void 0 : badgeStyle.fontFamily,
      fontSize: badgeStyle === null || badgeStyle === void 0 ? void 0 : badgeStyle.fontSize,
      fontWeight: badgeStyle === null || badgeStyle === void 0 ? void 0 : badgeStyle.fontWeight
    } : void 0,
    titleStyle: import_react_native.StyleSheet.flatten(props.style),
    accessibilityLabel: (_props_accessibilityLabel = props.accessibilityLabel) !== null && _props_accessibilityLabel !== void 0 ? _props_accessibilityLabel : content.label,
    accessibilityHint: props.accessibilityHint,
    disabled: props.disabled,
    onSelected: props.onPress
  });
}
function StackToolbarMenu(props) {
  var _props_title, _props_image, _ref, _ref1, _props_accessibilityLabel;
  var _content_icon, _content_icon1, _content_icon2, _content_icon3;
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.Menu must be used inside StackToolbar.");
  var content = getToolbarContent(props.children, props.icon, props.iconRenderingMode);
  var actions = import_react.Children.toArray(props.children).filter(function(child) {
    return isChildOfType(child, StackToolbarMenu) || isChildOfType(child, StackToolbarMenuAction);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_menu.MenuAction, {
    identifier,
    title: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : "",
    label: content.label || props.title,
    icon: (_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.sf,
    xcassetName: (_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.xcasset,
    image: (_props_image = props.image) !== null && _props_image !== void 0 ? _props_image : (_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.src,
    imageRenderingMode: (_ref = (_ref1 = (_content_icon3 = content.icon) === null || _content_icon3 === void 0 ? void 0 : _content_icon3.renderingMode) !== null && _ref1 !== void 0 ? _ref1 : props.iconRenderingMode) !== null && _ref !== void 0 ? _ref : props.tintColor ? "template" : "original",
    disabled: props.disabled,
    destructive: props.destructive,
    hidden: props.hidden,
    accessibilityLabel: (_props_accessibilityLabel = props.accessibilityLabel) !== null && _props_accessibilityLabel !== void 0 ? _props_accessibilityLabel : content.label || props.title,
    accessibilityHint: props.accessibilityHint,
    displayInline: props.inline,
    displayAsPalette: props.palette,
    singleSelection: props.singleSelection,
    preferredElementSize: props.elementSize,
    tintColor: props.tintColor,
    barButtonItemStyle: props.variant === "done" ? "prominent" : props.variant,
    sharesBackground: !props.separateBackground,
    hidesSharedBackground: props.hidesSharedBackground,
    titleStyle: import_react_native.StyleSheet.flatten(props.style),
    children: actions
  });
}
function StackToolbarMenuAction(props) {
  var _props_image, _ref, _ref1, _props_accessibilityLabel;
  var _content_icon, _content_icon1, _content_icon2, _content_icon3;
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.MenuAction must be used inside StackToolbar.Menu.");
  var content = getToolbarContent(props.children, props.icon, props.iconRenderingMode);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_menu.MenuAction, {
    identifier,
    title: content.label,
    icon: (_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.sf,
    xcassetName: (_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.xcasset,
    image: (_props_image = props.image) !== null && _props_image !== void 0 ? _props_image : (_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.src,
    imageRenderingMode: (_ref = (_ref1 = (_content_icon3 = content.icon) === null || _content_icon3 === void 0 ? void 0 : _content_icon3.renderingMode) !== null && _ref1 !== void 0 ? _ref1 : props.iconRenderingMode) !== null && _ref !== void 0 ? _ref : props.tintColor ? "template" : "original",
    disabled: props.disabled,
    destructive: props.destructive,
    discoverabilityLabel: props.discoverabilityLabel,
    subtitle: props.subtitle,
    accessibilityLabel: (_props_accessibilityLabel = props.accessibilityLabel) !== null && _props_accessibilityLabel !== void 0 ? _props_accessibilityLabel : content.label,
    accessibilityHint: props.accessibilityHint,
    isOn: props.isOn,
    keepPresented: props.unstable_keepPresented,
    hidden: props.hidden,
    onSelected: props.onPress
  });
}
function StackToolbarSpacer(props) {
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.Spacer must be used inside StackToolbar.");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_toolbar.ToolbarItem, {
    identifier,
    type: props.width === void 0 ? "fluidSpacer" : "fixedSpacer",
    width: props.width,
    hidden: props.hidden,
    sharesBackground: props.sharesBackground
  });
}
function StackToolbarSearchBarSlot(props) {
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.SearchBarSlot must be used inside StackToolbar.");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_toolbar.ToolbarItem, {
    identifier,
    type: "searchBar",
    hidden: props.hidden,
    hidesSharedBackground: props.hidesSharedBackground,
    sharesBackground: !props.separateBackground
  });
}
function StackToolbarView(props) {
  var placement = (0, import_react.useContext)(StackToolbarPlacementContext);
  var identifier = (0, import_react.useId)();
  if (import_react_native.Platform.OS !== "ios") return null;
  if (!placement) throw new Error("StackToolbar.View must be used inside StackToolbar.");
  if (props.hidden) return null;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_toolbar.ToolbarItem, {
    identifier,
    hidesSharedBackground: props.hidesSharedBackground,
    sharesBackground: !props.separateBackground,
    children: props.children
  });
}
var StackToolbar = Object.assign(StackToolbarComponent, {
  Button: StackToolbarButton,
  Menu: StackToolbarMenu,
  MenuAction: StackToolbarMenuAction,
  Spacer: StackToolbarSpacer,
  SearchBarSlot: StackToolbarSearchBarSlot,
  View: StackToolbarView,
  Label: StackToolbarLabel,
  Icon: StackToolbarIcon,
  Badge: StackToolbarBadge
});
//# sourceMappingURL=StackToolbar.js.map
